export const MULTIPLE_REGIMES_DEMAND = "multipleRegimes"
